import React from 'react';
import RequestComponent from '../Other/RequestComponent';
import OurTestimonials from '../Other/OurTestimonials';
import MarqueeText from '../Other/MarqueeText';

function AboutUs() {
    return (
        <div>
            <div class="common-hero" style={{width:'100%', backgroundSize:'cover'}}>
                <div class="container">
                    <div class="row align-items-center text-center">
                        <div class="col-lg-6 m-auto">
                            <div class="main-heading">
                                {/* <h1>About Us</h1>
                                <div class="space16"></div>
                                <span class="span"> <a href="/">Home</a> <span class="arrow"><i class="fa-regular fa-angle-right"></i></span> About Us</span> */}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <section class="hero10-benar">
                <div class="container-fluid p-0">
                    <div class="row">
                        <div class="col-12">
                           <MarqueeText/>
                        </div>
                    </div>

                    <div class="slider-after"></div>
                </div>
            </section>
            <div class="about2 about-page-sec sp">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-6">
                            <div class="about2-images">
                                <div class="image1">
                                    <img src="assets/img/about/about2-img1.png" alt="" />
                                </div>
                                <div class="image2">
                                    <img src="assets/img/1.png" alt="" />
                                </div>
                                <div class="image3">
                                    <img src="assets/img/about/about2-img3.png" alt="" />
                                </div>
                                <div class="counter-box">
                                    <h3>15</h3>
                                    <p>Years Of <br /> Experience</p>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6">
                            <div class="heading1">
                                {/* <span class="span"> About Us</span> */}
                                <h2>Empower Your Business With Our Expert Consulting & Technology Solutions</h2>
                                <div class="space16"></div>
                                <p>Welcome to M2V Consulting, an established ServiceNow partner with a passion for helping organizations across diverse industries unlock the full potential of the ServiceNow platform. Our team brings years of expertise in specialized experience in architecting and implementing scalable, enterprise-grade digital workflow solutions and a forward-thinking approach to ServiceNow advisory and delivery services.
                                </p>

                                <div class="space10"></div>
<p>We specialize in providing tailored, strategic solutions to optimize workflows, improve service delivery, and accelerate digital transformation. From IT Service Management (ITSM) to Customer Service Management (CSM), IT Operations Management (ITOM) to Security Operations (SecOps), we partner with you to craft solutions that are uniquely suited to your business needs.
</p>
                               
                                <div class="space30"></div>
                                {/* <div class="button">
                                    <a class="theme-btn1" href="/contact_us">Contact Us <span><i class="fa-solid fa-arrow-right"></i></span></a>
                                </div> */}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="solution about-solution sp">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-6">
                            <div class="images">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="image">
                                            <img src="assets/img/about/visiton-img1.png" alt="" />
                                        </div>
                                    </div>

                                    <div class="col-lg-6">
                                        <div class="space30"></div>
                                        <div class="image">
                                            <img src="assets/img/3.png" alt="" />
                                        </div>
                                    </div>

                                    <div class="col-lg-6">
                                        <div class="space30"></div>
                                        <div class="image">
                                            <img src="assets/img/2.png" alt="" />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="heading1">
                                {/* <span class="span"> Our Vision</span> */}
                                <h2>Our Vision</h2>
                                <div class="space16"></div>
                                <p>To be the trusted partner for organizations worldwide, empowering them to embrace digital transformation through innovative, efficient, and tailored ServiceNow solutions that drive sustainable growth and exceptional service experiences.
                                </p>
<p>At M2V Consulting, we go beyond implementation — we unlock the full potential of the ServiceNow platform. Whether you're just beginning your digital journey or scaling enterprise-wide capabilities, we’re the trusted partner to guide you every step of the way.</p>
                                {/* <div class="item-box">
                                    <div class="icon">
                                        <div class="">
                                            <img src="assets/img/icons/about-solution-iocn1.png" alt="" />
                                        </div>
                                    </div>
                                    <div class="">
                                        <h3><a href="#">Network Infrastructure Solutions</a></h3>
                                        <div class="space10"></div>
                                        <p>Build a reliable and secure network infrastructure that supports your <br/> business operations and enables seamless connectivity across all levels.</p>
                                    </div>
                                </div> */}

                                {/* <div class="item-box">
                                    <div class="icon">
                                        <div class="">
                                            <img src="assets/img/icons/about-solution-iocn2.png" alt="" />
                                        </div>
                                    </div>
                                    <div class="">
                                        <h3><a href="#">Managed It Services</a></h3>
                                        <div class="space10"></div>
                                        <p>Focus on your core business activities while we manage and optimize your <br/> IT environment with our comprehensive managed services.</p>
                                    </div>
                                </div> */}

                                <div class="space30"></div>
                                {/* <div class="">
                                    <a class="theme-btn1" href="/contact_us">Contact Us <span><i class="fa-solid fa-arrow-right"></i></span></a>
                                </div> */}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="solution sp bg1">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-6">
                            <div class="heading1">
                                {/* <span class="span"> Our Mission</span> */}
                                <h2>Our Mission</h2>
                                <div class="space16"></div>
                                <p>At M2V Consulting, we believe in delivering more than just software. We focus on building long-term relationships with our clients by offering insightful guidance, seamless implementations, and continuous support. We are committed to offering innovative, agile, and cost-effective solutions that drive real business value—helping you stay ahead of the curve in an ever-evolving digital landscape.</p>
                                <div class="space16"></div>
                                <p>"Our mission is to deliver high-quality, personalized ServiceNow advisory and implementation services that streamline operations, enhance service delivery, and create measurable business value. We strive to build lasting partnerships by providing expert guidance, cutting-edge solutions, and unmatched support to help our clients succeed in an increasingly digital world.

"</p>

                                <div class="space30"></div>
                                {/* <div class="">
                                    <a class="theme-btn1" href="/contact_us">Contact Us <span><i class="fa-solid fa-arrow-right"></i></span></a>
                                </div> */}
                            </div>
                        </div>

                        <div class="col-lg-6">
                            <div class="solution-images">
                                <div class="image1">
                                    <img src="assets/img/others/solution-img1.png" alt="" />
                                </div>
                                <div class="image2">
                                    <img src="assets/img/bg1234.jpeg" alt="" style={{backgroundSize:'cover'}} />
                                </div>
                                <div class="image3">
                                    <img src="assets/img/others/solution-img3.png" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
            {/* <div class="about-tabs sp bg1">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-10 text-center m-auto">
                            <div class="heading1">
                                <span class="span"> Our Story</span>
                                <h2>Our Company Story</h2>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-10 m-auto text-center">
                            <ul class="nav nav-pills tab-header-all mb-3" id="pills-tab" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link active" id="about-tab1-tab" data-bs-toggle="pill" data-bs-target="#about-tab1" type="button" role="tab" aria-controls="about-tab1" aria-selected="true">2017</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="about-tab2-tab" data-bs-toggle="pill" data-bs-target="#about-tab2" type="button" role="tab" aria-controls="about-tab2" aria-selected="false">2018</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="about-tab3-tab" data-bs-toggle="pill" data-bs-target="#about-tab3" type="button" role="tab" aria-controls="about-tab3" aria-selected="false">2019</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="about-tab4-tab" data-bs-toggle="pill" data-bs-target="#about-tab4" type="button" role="tab" aria-controls="about-tab4" aria-selected="false">2020</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="about-tab5-tab" data-bs-toggle="pill" data-bs-target="#about-tab5" type="button" role="tab" aria-controls="about-tab5" aria-selected="false">2021</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="about-tab6-tab" data-bs-toggle="pill" data-bs-target="#about-tab6" type="button" role="tab" aria-controls="about-tab6" aria-selected="false">2022</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="about-tab7-tab" data-bs-toggle="pill" data-bs-target="#about-tab7" type="button" role="tab" aria-controls="about-tab7" aria-selected="false">2023</button>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="space60"></div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="tab-content" id="pills-tabContent">
                                <div class="tab-pane fade show active" id="about-tab1" role="tabpanel" aria-labelledby="about-tab1-tab">
                                    <div class="row align-items-center">
                                        <div class="col-lg-6">
                                            <div class="tab-content-box">
                                                <div class="heading1">
                                                    <h5>2017 - A Legacy of Innovation</h5>
                                                    <div class="space24"></div>
                                                    <p><span class="text">Early Years:</span> In the early years, Steve Jobs recognized the growing importance of technology in business and set out to create a company that could help organizations leverage the power of digital innovation. With a small team of passionate individuals.</p>
                                                    <div class="space16"></div>
                                                    <p><span class="text">Expansion & Innovation:</span> As technology continued to evolve, so did [Company Name]. We expanded our service offerings to include a wide range of solutions, from cybersecurity and cloud computing to data analytics and artificial intelligence.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-lg-6">
                                            <div class="image">
                                                <img src="assets/img/about/about-tab-img.png" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="about-tab2" role="tabpanel" aria-labelledby="about-tab2-tab">
                                    <div class="row align-items-center">
                                        <div class="col-lg-6">
                                            <div class="tab-content-box">
                                                <div class="heading1">
                                                    <h5>2018 - A Legacy of Innovation</h5>
                                                    <div class="space24"></div>
                                                    <p><span class="text">Early Years:</span> In the early years, Steve Jobs recognized the growing importance of technology in business and set out to create a company that could help organizations leverage the power of digital innovation. With a small team of passionate individuals.</p>
                                                    <div class="space16"></div>
                                                    <p><span class="text">Expansion & Innovation:</span> As technology continued to evolve, so did [Company Name]. We expanded our service offerings to include a wide range of solutions, from cybersecurity and cloud computing to data analytics and artificial intelligence.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-lg-6">
                                            <div class="image">
                                                <img src="assets/img/about/about-tab-img.png" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="about-tab3" role="tabpanel" aria-labelledby="about-tab3-tab">
                                    <div class="row align-items-center">
                                        <div class="col-lg-6">
                                            <div class="tab-content-box">
                                                <div class="heading1">
                                                    <h5>2019 - A Legacy of Innovation</h5>
                                                    <div class="space24"></div>
                                                    <p><span class="text">Early Years:</span> In the early years, Steve Jobs recognized the growing importance of technology in business and set out to create a company that could help organizations leverage the power of digital innovation. With a small team of passionate individuals.</p>
                                                    <div class="space16"></div>
                                                    <p><span class="text">Expansion & Innovation:</span> As technology continued to evolve, so did [Company Name]. We expanded our service offerings to include a wide range of solutions, from cybersecurity and cloud computing to data analytics and artificial intelligence.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-lg-6">
                                            <div class="image">
                                                <img src="assets/img/about/about-tab-img.png" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="about-tab4" role="tabpanel" aria-labelledby="about-tab4-tab">
                                    <div class="row align-items-center">
                                        <div class="col-lg-6">
                                            <div class="tab-content-box">
                                                <div class="heading1">
                                                    <h5>2020 - A Legacy of Innovation</h5>
                                                    <div class="space24"></div>
                                                    <p><span class="text">Early Years:</span> In the early years, Steve Jobs recognized the growing importance of technology in business and set out to create a company that could help organizations leverage the power of digital innovation. With a small team of passionate individuals.</p>
                                                    <div class="space16"></div>
                                                    <p><span class="text">Expansion & Innovation:</span> As technology continued to evolve, so did [Company Name]. We expanded our service offerings to include a wide range of solutions, from cybersecurity and cloud computing to data analytics and artificial intelligence.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-lg-6">
                                            <div class="image">
                                                <img src="assets/img/about/about-tab-img.png" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="about-tab5" role="tabpanel" aria-labelledby="about-tab5-tab">
                                    <div class="row align-items-center">
                                        <div class="col-lg-6">
                                            <div class="tab-content-box">
                                                <div class="heading1">
                                                    <h5>2021 - A Legacy of Innovation</h5>
                                                    <div class="space24"></div>
                                                    <p><span class="text">Early Years:</span> In the early years, Steve Jobs recognized the growing importance of technology in business and set out to create a company that could help organizations leverage the power of digital innovation. With a small team of passionate individuals.</p>
                                                    <div class="space16"></div>
                                                    <p><span class="text">Expansion & Innovation:</span> As technology continued to evolve, so did [Company Name]. We expanded our service offerings to include a wide range of solutions, from cybersecurity and cloud computing to data analytics and artificial intelligence.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-lg-6">
                                            <div class="image">
                                                <img src="assets/img/about/about-tab-img.png" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="about-tab6" role="tabpanel" aria-labelledby="about-tab6-tab">
                                    <div class="row align-items-center">
                                        <div class="col-lg-6">
                                            <div class="tab-content-box">
                                                <div class="heading1">
                                                    <h5>2022 - A Legacy of Innovation</h5>
                                                    <div class="space24"></div>
                                                    <p><span class="text">Early Years:</span> In the early years, Steve Jobs recognized the growing importance of technology in business and set out to create a company that could help organizations leverage the power of digital innovation. With a small team of passionate individuals.</p>
                                                    <div class="space16"></div>
                                                    <p><span class="text">Expansion & Innovation:</span> As technology continued to evolve, so did [Company Name]. We expanded our service offerings to include a wide range of solutions, from cybersecurity and cloud computing to data analytics and artificial intelligence.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-lg-6">
                                            <div class="image">
                                                <img src="assets/img/about/about-tab-img.png" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="about-tab7" role="tabpanel" aria-labelledby="about-tab7-tab">
                                    <div class="row align-items-center">
                                        <div class="col-lg-6">
                                            <div class="tab-content-box">
                                                <div class="heading1">
                                                    <h5>2023 - A Legacy of Innovation</h5>
                                                    <div class="space24"></div>
                                                    <p><span class="text">Early Years:</span> In the early years, Steve Jobs recognized the growing importance of technology in business and set out to create a company that could help organizations leverage the power of digital innovation. With a small team of passionate individuals.</p>
                                                    <div class="space16"></div>
                                                    <p><span class="text">Expansion & Innovation:</span> As technology continued to evolve, so did [Company Name]. We expanded our service offerings to include a wide range of solutions, from cybersecurity and cloud computing to data analytics and artificial intelligence.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-lg-6">
                                            <div class="image">
                                                <img src="assets/img/about/about-tab-img.png" alt="" />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* <OurTestimonials/> */}
            {/* <div class="team2 about-page-team sp bg1">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6 m-auto text-center">
                            <div class="heading1">
                                <span class="span"> Our Team</span>
                                <h2>Meet With Our Expert Team</h2>
                            </div>
                        </div>
                    </div>

                    <div class="space30"></div>
                    <div class="row">
                        <div class="col-lg-3 col-md-6">
                            <div class="team-box">
                                <div class="image-area">
                                    <div class="image">
                                        <img src="assets/img/team/team2-img1.png" alt="" />
                                    </div>
                                    <div class="icon-area">
                                        <ul>
                                            <li><a href="#"><i class="fa-brands fa-linkedin-in"></i></a></li>
                                            <li><a href="#"><i class="fa-brands fa-x-twitter"></i></a></li>
                                            <li><a href="#"><i class="fa-brands fa-youtube"></i></a></li>
                                            <li><a href="#"><i class="fa-brands fa-instagram"></i></a></li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="space30"></div>
                                <div class="heading1">
                                    <h4><a href="#">John Doe</a></h4>
                                    <div class="space10"></div>
                                    <p>CEO & Founder</p>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-3 col-md-6">
                            <div class="team-box">
                                <div class="image-area">
                                    <div class="image">
                                        <img src="assets/img/team/team2-img2.png" alt="" />
                                    </div>
                                    <div class="icon-area">
                                        <ul>
                                            <li><a href="#"><i class="fa-brands fa-linkedin-in"></i></a></li>
                                            <li><a href="#"><i class="fa-brands fa-x-twitter"></i></a></li>
                                            <li><a href="#"><i class="fa-brands fa-youtube"></i></a></li>
                                            <li><a href="#"><i class="fa-brands fa-instagram"></i></a></li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="space30"></div>
                                <div class="heading1">
                                    <h4><a href="#">Jane Smith</a></h4>
                                    <div class="space10"></div>
                                    <p>Chef Technology Officer</p>
                                </div>

                            </div>
                        </div>


                        <div class="col-lg-3 col-md-6">
                            <div class="team-box">
                                <div class="image-area">
                                    <div class="image">
                                        <img src="assets/img/team/team2-img3.png" alt="" />
                                    </div>
                                    <div class="icon-area">
                                        <ul>
                                            <li><a href="#"><i class="fa-brands fa-linkedin-in"></i></a></li>
                                            <li><a href="#"><i class="fa-brands fa-x-twitter"></i></a></li>
                                            <li><a href="#"><i class="fa-brands fa-youtube"></i></a></li>
                                            <li><a href="#"><i class="fa-brands fa-instagram"></i></a></li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="space30"></div>
                                <div class="heading1">
                                    <h4><a href="#">Sarah Thompson </a></h4>
                                    <div class="space10"></div>
                                    <p>Head of Project Management</p>
                                </div>

                            </div>
                        </div>

                        <div class="col-lg-3 col-md-6">
                            <div class="team-box">
                                <div class="image-area">
                                    <div class="image">
                                        <img src="assets/img/team/team2-img4.png" alt="" />
                                    </div>
                                    <div class="icon-area">
                                        <ul>
                                            <li><a href="#"><i class="fa-brands fa-linkedin-in"></i></a></li>
                                            <li><a href="#"><i class="fa-brands fa-x-twitter"></i></a></li>
                                            <li><a href="#"><i class="fa-brands fa-youtube"></i></a></li>
                                            <li><a href="#"><i class="fa-brands fa-instagram"></i></a></li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="space30"></div>
                                <div class="heading1">
                                    <h4><a href="#">David Garcia</a></h4>
                                    <div class="space10"></div>
                                    <p>Lead Software Engineer</p>
                                </div>

                            </div>
                        </div>


                    </div>

                </div>
            </div> */}
            <RequestComponent/>
        </div>
    );
}

export default AboutUs;